var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboardStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8063 18.269C0.906066 17.369 0.400175 16.1483 0.399903 14.8754L0.399902 5.0002C0.399902 3.72716 0.905615 2.50626 1.80579 1.60608C2.70596 0.705908 3.92686 0.200196 5.1999 0.200196L14.7999 0.200195C16.0729 0.200195 17.2938 0.705907 18.194 1.60608C19.0942 2.50626 19.5999 3.72716 19.5999 5.0002V14.8754C19.5992 16.1478 19.0933 17.3678 18.1935 18.2674L11.1311 25.3314C10.8311 25.6313 10.4242 25.7999 9.9999 25.7999C9.57564 25.7999 9.16875 25.6313 8.8687 25.3314L1.8063 18.269ZM3.97422 7.00628C4.21396 6.75683 4.53909 6.61669 4.87809 6.61669C5.21709 6.61669 5.54221 6.75683 5.78195 7.00628L9.99191 11.3881L14.2019 7.00628C14.3198 6.87919 14.4609 6.77782 14.6168 6.70808C14.7728 6.63834 14.9406 6.60164 15.1103 6.6001C15.2801 6.59857 15.4484 6.63223 15.6056 6.69914C15.7627 6.76605 15.9054 6.86485 16.0254 6.98979C16.1455 7.11473 16.2404 7.2633 16.3047 7.42683C16.369 7.59037 16.4013 7.76559 16.3999 7.94227C16.3984 8.11895 16.3631 8.29356 16.2961 8.45591C16.2291 8.61825 16.1317 8.76508 16.0096 8.88783L10.8958 14.2105C10.656 14.4599 10.3309 14.6001 9.99191 14.6001C9.65291 14.6001 9.32779 14.4599 9.08804 14.2105L3.97422 8.88783C3.73454 8.6383 3.5999 8.2999 3.5999 7.94706C3.5999 7.59422 3.73454 7.25582 3.97422 7.00628Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardStaking);
export default __webpack_public_path__ + "static/media/dashboard-staking.259b4ae661ea4e3260e268cc5fc86f7b.svg";
export { ForwardRef as ReactComponent };